"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccordionBlock_1 = require("./AccordionBlock");
exports.default = AccordionBlock_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Accordion/components/AccordionBlock/index.js
// module id = 666
// module chunks = 8